import type { OwnerOutput } from "@core/composables"

function normalizeConsentEmail(value: string | null | undefined): string {
    return (value ?? "").trim().toLowerCase()
}

/**
 * Emails du consentement métier à comparer au titulaire saisi (signataire + titulaire user).
 */
function getConsentSignataireAndTitulaireEmails(
    consentement: unknown
): string[] {
    if (!consentement || typeof consentement !== "object") return []
    const c = consentement as Record<string, unknown>
    const out: string[] = []

    const signataire = c.signataire as Record<string, unknown> | undefined
    const signUser = signataire?.user as Record<string, unknown> | undefined
    const signEmail = normalizeConsentEmail(
        typeof signUser?.username === "string" ? signUser.username : ""
    )
    if (signEmail) out.push(signEmail)

    const titulaire = c.titulaire as Record<string, unknown> | undefined
    const titUser = titulaire?.user as Record<string, unknown> | undefined
    const titEmail = normalizeConsentEmail(
        typeof titUser?.username === "string" ? titUser.username : ""
    )
    if (titEmail) out.push(titEmail)

    return [...new Set(out)]
}

/**
 * true si l’email du titulaire saisi (owner.user.username) correspond au signataire ou au titulaire du consentement retourné par la recherche source.
 * Utilisé pour proposer une demande SHARE (même titulaire, pas d’accès entreprise) plutôt qu’une demande SIGN.
 */
export function doesOwnerEmailMatchConsentForShare(
    owner: OwnerOutput | null | undefined,
    consentement: unknown
): boolean {
    const ownerEmail = normalizeConsentEmail(owner?.user?.username)
    if (!ownerEmail) return false
    return getConsentSignataireAndTitulaireEmails(consentement).some(
        (e) => e === ownerEmail
    )
}
